export const NO_SUBSCRIPTION = 'no subscription';
